export default __webpack_public_path__ + "static/media/partner-2.895c4f93.png";